import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CityContext = createContext(null);
export const useCity = () => useContext(CityContext);

export function CityProvider({ children }) {
  const [cities, setCities] = useState(["Kundapura", "Udupi", "Manipal", "Brahmavar", "Kota", "Byndoor", "Saligrama", "Mangaluru"]);
  const [city, setCityState] = useState(() => localStorage.getItem("mme_city") || "Kundapura");

  useEffect(() => {
    api.get("/cities").then(({ data }) => {
      setCities(data.cities);
      if (!localStorage.getItem("mme_city")) setCityState(data.default);
    }).catch(() => {});
  }, []);

  const setCity = (c) => {
    setCityState(c);
    if (c) localStorage.setItem("mme_city", c);
    else localStorage.removeItem("mme_city");
  };

  return (
    <CityContext.Provider value={{ city, setCity, cities }}>
      {children}
    </CityContext.Provider>
  );
}
